import { InputConfig } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountOrganizationEmployeeCooperationStatusChoices,
  useGetJobPositionsLazyQuery,
} from "@graphql/generated";

export interface IFormData {
  name?: string;
  jobPosition?: { node: { id: string } };
  date?: Date[];
  status?: { value: AuthAccountOrganizationEmployeeCooperationStatusChoices & "all" };
}

export const inputConfigs: InputConfig[] = [
  {
    name: "name",
    previewSize: {
      sm: 12,
      md: 6,
      lg: 3,
    },
    inputProps: {
      type: "text",
      label: "Name",
      placeholder: "Enter employee name",
    },
  },
  {
    name: "jobPosition",
    previewSize: {
      sm: 12,
      md: 6,
      lg: 3,
    },
    inputProps: {
      type: "searcher",
      label: "Job Post",
      placeholder: "Select job post",
      labelKey: "title",
      valueKey: "id",
      useLazyQuery: useGetJobPositionsLazyQuery,
      dataPath: "organization.jobPosition.list",
    },
  },
  {
    name: "status",
    previewSize: {
      sm: 12,
      md: 6,
      lg: 3,
    },
    inputProps: {
      type: "searcher",
      label: "Status",
      placeholder: "Select status",
      labelKey: "label",
      valueKey: "value",
      items: [
        { value: "all", label: "All" },
        { value: AuthAccountOrganizationEmployeeCooperationStatusChoices.ACTIVE, label: "Active" },
        { value: AuthAccountOrganizationEmployeeCooperationStatusChoices.SUSPENDED, label: "Suspended" },
        { value: AuthAccountOrganizationEmployeeCooperationStatusChoices.FINISHED, label: "Ended" },
        { value: AuthAccountOrganizationEmployeeCooperationStatusChoices.FIRED, label: "Fired" },
        { value: AuthAccountOrganizationEmployeeCooperationStatusChoices.AWAITING, label: "Awaiting Start" },
      ],
    },
  },
  {
    name: "date",
    previewSize: {
      sm: 12,
      md: 6,
      lg: 3,
    },
    inputProps: {
      type: "date",
      label: "Hired date",
      placeholder: "Select date",
      range: true,
    },
  },
];
